window.onload = function loadStuff() {
  var win, doc, img, body, enhancedClass, smallPictureClass;
  // Quit early if older browser (e.g. IE8).
  if (!('addEventListener' in window)) {
    return;
  }

  win = window;
  doc = win.document;
  // Get body class
  body = doc.querySelector('body');
  smallPictureClass = body.className;

  if(!smallPictureClass)
    return;

  img = new Image();
  enhancedClass = "random-background " + smallPictureClass + '-full';

  var bigSrc = "/assets/images/" + smallPictureClass + ".jpg";

  // When full-size picture will be loaded, update body class to display it
  img.onload = function() {
    body.className = enhancedClass;
  };
  // Finally, trigger the full-size picture loading
  if (bigSrc) {
    img.src = bigSrc;
  }
};


// WEBPACK FOOTER //
// ./js/legacy/background-loading.js